import { type Navigation } from '@models/Navigation';
import { formatDateTime } from '@utils/dateFormatUtils';

const options = {
    to: import.meta.env.VITE_FEEDBACK_RECIPIENT,
    subject: `SE ICS - bug report/feedback from [${window.location.hostname}]`,
    body: `I have found a bug/I want to suggest something!%0D%0A%0D%0A
BUG:%0D%0A
What I did: DESCRIBE%0D%0A
What happened: DESCRIBE%0D%0A
What I expected: DESCRIBE%0D%0A
---------%0D%0A
Feedback/suggestion:%0D%0A
INPUT%0D%0A%0D%0A%0D%0A%0D%0A%0D%0A
---------%0D%0A
URL: ${window.document.URL}%0D%0A
Time: ${formatDateTime(new Date())}%0D%0A
User Agent: ${navigator.userAgent}%0D%0A`,
};

export const FooterMenu: Navigation = {
    id: 'secondary',
    items: [
        {
            label: 'Send feedback/report a bug',
            to: `mailto:${options.to}?subject=${options.subject}&body=${options.body}`,
            icon: 'mail',
            admin: false,
        },
    ],
};
